import rootedLogo from '../assets/reviews/rooted.png';
import rootedClientPhoto from '../assets/reviews/rootedClientPhoto.png';
import lernweiseLogo from '../assets/reviews/lernweise.png';
import lernweiseClientPhoto from '../assets/reviews/lernweiseClientPhoto.png';
import probuddyLogo from '../assets/reviews/probuddy.svg';
import probuddyClientPhoto from '../assets/reviews/probuddyClientPhoto.png';
import renulogixLogo from '../assets/reviews/renulogix.png';
import renulogixClientPhoto from '../assets/reviews/renulogixClientPhoto.png';


/**
 * Client testimonials.
 *
 * `review`  — the client's full, unedited words. Never shortened here.
 * `excerpt` — an editorial trim used in the card grid where the full text
 *             would unbalance the layout. Optional; falls back to `review`.
 * `featured`— renders as the large dark card.
 * `rating`  — optional. Renders a star row; the design uses it as an accent
 *             on a single card rather than repeating it on every one.
 */
export const configReviews = [
  {
    id: 'Rooted',
    title: 'Rooted',
    logo: rootedLogo,
    review:
      "After a long search, including unsuccessful negotiations with three other providers, my company chose to work with Gitribe for upgrades to our marketplace, integrations with Zendesk, and other needs. Gitribe was the best decision we could have made. They were willing to work on a fixed-price contract on a milestone basis, giving us price certainty from the beginning. Everything they did ended up working excellently. And best of all, they were never difficult about several small and unexpected side needs that came up during the course of making our planned upgrades. The Gitribe team was generous and flexible, which meant that we, as laypeople, didn't have to anticipate every last tiny task or need before starting.",
    excerpt:
      'After a long search, including unsuccessful negotiations with three other providers, my company chose Gitribe. They were willing to work on a fixed-price contract on a milestone basis, giving us price certainty from the beginning — and everything they did ended up working excellently.',
    featured: true,
    clientName: 'Jack Woodruff',
    clientPosition: 'Housing Director - Rooted',
    clientPhoto: rootedClientPhoto,
  },
  {
    id: 'Lernweise',
    title: 'Lernweise',
    logo: lernweiseLogo,
    review:
      "We partnered with Gitribe to build a highly specialized tutoring MVP, and the collaboration has been excellent from start to finish. Gitribe demonstrated deep technical expertise integrating key third-party tools like Stripe, Lessonspace, and Freshworks, and delivering a clean, scalable front-end based on our specific needs. They were flexible, proactive, and consistently met tight deadlines, all while maintaining high code quality and clear communication. What stood out most was their ability to translate complex business requirements into a well-functioning product, with minimal hand-holding. Highly recommended for any custom projects, reliable, sharp, and genuinely collaborative.",
    excerpt:
      'Deep technical expertise integrating Stripe, Lessonspace and Freshworks, and delivering a clean, scalable front-end. Reliable, sharp, genuinely collaborative.',
    rating: 5,
    clientName: 'Florian Zandbergen',
    clientPosition: 'CEO - SchoolTalent',
    clientPhoto: lernweiseClientPhoto,
  },
  {
    id: 'Probuddy',
    title: 'Probuddy',
    logo: probuddyLogo,
    review:
      "The cooperation with Gitribe was exceptionally good! The Gitribe team has not only done a fantastic job in the form of the product, they also advised me and did a lot of work around the project. So I can absolutely recommend them. I am really thrilled! I will certainly work with Gitribe more often in the future. Thanks, Gitribe!",
    clientName: 'Christo Wiese',
    clientPosition: 'Founder - Probuddy',
    clientPhoto: probuddyClientPhoto,
  },
  {
    id: 'Renulogix',
    title: 'Renulogix',
    logo: renulogixLogo,
    review:
      "As a project manager for cloud-based clean-tech software developments, I always enjoy working with Gitribe. The team is knowledgeable and creative. Thank you for your services.",
    clientName: 'Amir Salahi',
    clientPosition: 'Project Manager - Renulogix',
    clientPhoto: renulogixClientPhoto,
  }
];
